import {SurveyType, SurveyScope, SurveyPreset} from 'client/common/types';
import {createUrl} from 'client/common/utils/history';
import cfg from 'client/common/utils/client-config';
import {getCurrentOrg} from 'client/common/hooks/orgs';

import {PreviewDevice} from 'client/common/components/preview/types';

interface GenSurveyStatisticsParams {
    slug: string;
    surveyType: SurveyType | undefined;
    isRelative?: boolean;
    surveyScope?: SurveyScope;
}

export function genSurveyLink({slug, surveyType, isRelative}: GenSurveyStatisticsParams): string {
    let path: string;

    const org = getCurrentOrg();

    switch (surveyType) {
        case 'ux':
            path = `/ux/${slug}`;
            break;
        case 'creative':
            path = `/creative/${slug}`;
            break;
        case 'bordomatik':
            path = `/bordomatik/${slug}`;
            break;
        default:
            path = `/qs/${slug}`;
            break;
    }

    return createUrl({link: path, relative: isRelative, extraSearchParams: {org}});
}

export function genStatisticsLink({
    slug,
    surveyType,
    isRelative,
    surveyScope = SurveyScope.Yandex
}: GenSurveyStatisticsParams): string {
    let path;

    const org = getCurrentOrg();

    switch (surveyType) {
        case 'ux':
            path = `/ux/statistics/${slug}`;
            break;
        case 'creative':
            path = `/creative/statistics/${slug}`;
            break;
        case 'bordomatik':
            path = `/bordomatik/statistics/${slug}`;
            break;
        default:
            path = `/quicksurvey/statistics/${slug}`;
            break;
    }

    return createUrl({link: path, relative: isRelative, surveyScope, extraSearchParams: {org}});
}

export function getSurveyPreviewLink({
    slug,
    device,
    scope,
    preset
}: {
    slug: string;
    device: PreviewDevice;
    scope?: SurveyScope;
    preset?: SurveyPreset;
}): string {
    let host = cfg.preview.hosts.default;

    if (scope === SurveyScope.YandexNet && cfg.preview.hosts.yandexNet) {
        host = cfg.preview.hosts.yandexNet;
    } else if (scope === SurveyScope.YandexTeam && cfg.preview.hosts.yandexTeam) {
        host = cfg.preview.hosts.yandexTeam;
    }

    const pollPart = preset && [
        SurveyPreset.YandexActiveFeedback,
        SurveyPreset.YandexPassiveFeedback,
        SurveyPreset.YandexMorda
    ].includes(preset) ? '/poll/feedback/' : '/poll/';

    return device === 'panel' ? `${host}${pollPart}${slug}` : `${host}/poll/video/${slug}?_theme_=video`;
}
